module.exports = __webpack_public_path__ + "static/media/262510.38d4447c.jpg";